module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2023_07.36d6e196.webp";